import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Humar bi moral postati legenda, pa ne bo",
  "description": "",
  "published": "2009-11-14T00:00:00.000Z",
  "redirect_from": ["/blog/humar-bi-moral-postati-legenda-pa-ne-bo/swizec/829"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2009/11/6054550-300x225.jpg",
        "alt": "6054550",
        "title": "6054550"
      }}></img>{`Tokrat za spremembo pi`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      